
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta } from "/src/pages/login.vue?macro=true";
import { default as indexB3IJvu8pTpGZNEY0OKoW_450VdJknlEvHd33kuHT3UC4AMeta } from "/src/pages/mappa/index.vue?macro=true";
import { default as indexObTkwh9UPqbY9tpxl5hmElRB5nhpgNhD36yZqktmctUMeta } from "/src/pages/pulizia/index.vue?macro=true";
import { default as index3RWrjnc5BKbrYbqKtfbfqKQE40fs4PyEzOJTiEAPhUEMeta } from "/src/pages/vettori/index.vue?macro=true";
import { default as _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta } from "/src/pages/docs/[...slug].vue?macro=true";
import { default as indexd7woIbHiz4PXLtNvB1K5QWGtbtPwFEYG3FNbqcygSOwMeta } from "/src/pages/settings/index.vue?macro=true";
import { default as indexzyO7jCU5mvXbTVSWxW2sKPB8wugfzCKCDl7uh3q1legMeta } from "/src/pages/notifiche/index.vue?macro=true";
import { default as _91id_93I4XgAPc4u6VC1__I7vD_45IPtfFdyN0UMNqlTr7jpHCVwMeta } from "/src/pages/crm/prospect/[id].vue?macro=true";
import { default as index7Fq7rDTe_pzRaYfq102xthcdDKK5yFvDWW_45JaQzj_7wMeta } from "/src/pages/crm/prospect/index.vue?macro=true";
import { default as indexTrzgjx1LDquZLaiFpid0bWFPwhCBxpn3D4nV0vD_45UhAMeta } from "/src/pages/crm/calendario/index.vue?macro=true";
import { default as indexhnVEpCmJSHCX2gQtpmIA7Pm0Mrt1rz7fvYgOZqt8pawMeta } from "/src/pages/amministrazione/index.vue?macro=true";
import { default as password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta } from "/src/pages/public/password-reset.vue?macro=true";
import { default as index52UP2Zrc2jcvhuQIzh3LfSuV_yjJv2WpiasRwkxWzKQMeta } from "/src/pages/pulizia/gestione/index.vue?macro=true";
import { default as _91id_93LnYl3J2l_456Blh_45zWLb3iTvdnaLioB83gJokAE7KRKG4Meta } from "/src/pages/anagrafica/clienti/[id].vue?macro=true";
import { default as index66aE3bR6LPFQnShuQ9p5t_juxa2Y9j9MIVxBS41_45_459EMeta } from "/src/pages/magazzino/esolver/index.vue?macro=true";
import { default as index930WYtS98ddgJxv29oD_45fPy9fURM6nJaezSWRj39O3wMeta } from "/src/pages/anagrafica/clienti/index.vue?macro=true";
import { default as indext1_CymzDynuQ44Q7pV082ChiaEG1DcycL_45Px4DZMqrwMeta } from "/src/pages/magazzino/articoli/index.vue?macro=true";
import { default as indexKx6VCUhnEqelsAbXZJQUvsUpeTuqOU1IqNNh_451BhVeYMeta } from "/src/pages/magazzino/gestione/index.vue?macro=true";
import { default as _91id_93ZVtddxTi_45OeHHB2TxIgjmCxjCp3sDxBlwxnF7vB4edAMeta } from "/src/pages/prestazioni/offerte/[id].vue?macro=true";
import { default as indexKprNnb0LYlxjLyef70YxJ0LymtH9TYJwth_aefljxlcMeta } from "/src/pages/prestazioni/ordini/index.vue?macro=true";
import { default as indexJUWRvAUOKYJG4d6iCNTT6IJkc2i9_45uwLy9MV2BxM3VIMeta } from "/src/pages/pulizia/calendario/index.vue?macro=true";
import { default as indexsNg9NcGJ1oV4ikbidJEdQtX_45kWuJEhCijawDd6FGVDQMeta } from "/src/pages/commerciale/listini/index.vue?macro=true";
import { default as indexp3cSoVCNKwjUqozWynJqf1Bh5W87tScSHD_45F22EI3t0Meta } from "/src/pages/magazzino/automezzi/index.vue?macro=true";
import { default as indexoVg545KJ1Qv3E0WHgbuwZjdSOZHZn3mn32RFzL38Xm8Meta } from "/src/pages/prestazioni/offerte/index.vue?macro=true";
import { default as index6LPdoFzOSgfn8JLQswONBM4QcBrtMiGabtXSIIpmHJMMeta } from "/src/pages/anagrafica/capi_area/index.vue?macro=true";
import { default as indexBXAKWR9GA2_45ebOUop_45RWjE5WL6GvGq8A0dUaR1DF4zQMeta } from "/src/pages/amministrazione/fatture/index.vue?macro=true";
import { default as _91id_93C62Q0abD0x_455OpbfKfOZAH60FBa2PmV_45iUX9MmlVd54Meta } from "/src/pages/anagrafica/concessionari/[id].vue?macro=true";
import { default as indexcqThJuHr6cdBGCM0gpNqMxsSTolLk4VX9uxQaBmwTscMeta } from "/src/pages/prestazioni/ordini/[id]/index.vue?macro=true";
import { default as index82ArsAs8HPgk24XkSDLH9Po7_45bThMAzvy18Thre4xE8Meta } from "/src/pages/prestazioni/ordini/crea/index.vue?macro=true";
import { default as indexpgzbl03oolTD4HC_pPCpADZS0ZKpQd6jycuOo2GCC78Meta } from "/src/pages/anagrafica/concessionari/index.vue?macro=true";
import { default as indexTH7ISCncmUIEkaPqlXUzS_3jP_45TV_gGea6PWJgoBIIwMeta } from "/src/pages/anagrafica/gestione_file/index.vue?macro=true";
import { default as indexRetDUlBq7e1B3f4HF9zaiU4BcDI9ZPvgSjMVssxyP4gMeta } from "/src/pages/prestazioni/offerte/crea/index.vue?macro=true";
import { default as _91id_93vaZMfsmKkp66PdLiZfFWlOwmgkMOJDQp_45XhJQYfE5WIMeta } from "/src/pages/prestazioni/offerte/recap/[id].vue?macro=true";
import { default as indexfjZctePbmhiLuKQwW3easA2K_Hg32LqHmp8eVujXTjoMeta } from "/src/pages/amministrazione/insurance/index.vue?macro=true";
import { default as indexG8kl74fuA0E22RhjjBBttdWYh9MS04QyjShVsy3cZJMMeta } from "/src/pages/amministrazione/pro-forma/index.vue?macro=true";
import { default as indexFqRlEbMOmjHmw_ZloqWnm0hVKknpmaspZbBkkiedJrMMeta } from "/src/pages/commerciale/tipi_locazione/index.vue?macro=true";
import { default as index9eNPO_45gL32CnmP7RC3nrTwh0adhrL_45tn1XOg3cDdhv8Meta } from "/src/pages/prestazioni/offerte/importa/index.vue?macro=true";
import { default as indexO04KHnBd9TE2uMlo_LOOzGKigrqyVDtpgVnqDKGXSmcMeta } from "/src/pages/pulizia/anagrafica-pulitori/index.vue?macro=true";
import { default as _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta } from "/src/pages/password-reset/confirm/[uid]/[token].vue?macro=true";
import { default as indexpl6FI_vQ065DLHaa7vViusW29b98VY5PyCFGdToU_45V4Meta } from "/src/pages/amministrazione/fatture-veicoli/index.vue?macro=true";
import { default as index6tD_45JW122TPBlrzJlupAVYIIGgoxNl9GdmAU_FsrlgsMeta } from "/src/pages/amministrazione/riepilogo-fatture/index.vue?macro=true";
export default [
  {
    name: "index___it",
    path: "/it",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/login",
    meta: login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___ro",
    path: "/ro/login",
    meta: login7COOQeYKQwisHoj2xkTxmCi9HyQxCOyTj3KOsyypuxYMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "mappa___it",
    path: "/it/mappa",
    component: () => import("/src/pages/mappa/index.vue")
  },
  {
    name: "mappa___en",
    path: "/en/map",
    component: () => import("/src/pages/mappa/index.vue")
  },
  {
    name: "mappa___fr",
    path: "/carte",
    component: () => import("/src/pages/mappa/index.vue")
  },
  {
    name: "mappa___es",
    path: "/es/mapa",
    component: () => import("/src/pages/mappa/index.vue")
  },
  {
    name: "mappa___ro",
    path: "/ro/harta",
    component: () => import("/src/pages/mappa/index.vue")
  },
  {
    name: "pulizia___it",
    path: "/it/pulizia",
    component: () => import("/src/pages/pulizia/index.vue")
  },
  {
    name: "pulizia___en",
    path: "/en/cleaning",
    component: () => import("/src/pages/pulizia/index.vue")
  },
  {
    name: "pulizia___fr",
    path: "/nettoyage",
    component: () => import("/src/pages/pulizia/index.vue")
  },
  {
    name: "pulizia___es",
    path: "/es/limpieza",
    component: () => import("/src/pages/pulizia/index.vue")
  },
  {
    name: "pulizia___ro",
    path: "/ro/curatenie",
    component: () => import("/src/pages/pulizia/index.vue")
  },
  {
    name: "vettori___it",
    path: "/it/vettori",
    component: () => import("/src/pages/vettori/index.vue")
  },
  {
    name: "vettori___en",
    path: "/en/carriers",
    component: () => import("/src/pages/vettori/index.vue")
  },
  {
    name: "vettori___fr",
    path: "/transporteurs",
    component: () => import("/src/pages/vettori/index.vue")
  },
  {
    name: "vettori___es",
    path: "/es/transportistas",
    component: () => import("/src/pages/vettori/index.vue")
  },
  {
    name: "vettori___ro",
    path: "/ro/transportatori",
    component: () => import("/src/pages/vettori/index.vue")
  },
  {
    name: "docs-slug___it",
    path: "/it/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta || {},
    component: () => import("/src/pages/docs/[...slug].vue")
  },
  {
    name: "docs-slug___en",
    path: "/en/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta || {},
    component: () => import("/src/pages/docs/[...slug].vue")
  },
  {
    name: "docs-slug___fr",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta || {},
    component: () => import("/src/pages/docs/[...slug].vue")
  },
  {
    name: "docs-slug___es",
    path: "/es/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta || {},
    component: () => import("/src/pages/docs/[...slug].vue")
  },
  {
    name: "docs-slug___ro",
    path: "/ro/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93bX4ZLMZVAPeUR0Yxl30MjactobfGZpnAKO0ENarkNHcMeta || {},
    component: () => import("/src/pages/docs/[...slug].vue")
  },
  {
    name: "settings___it",
    path: "/it/impostazioni",
    component: () => import("/src/pages/settings/index.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    component: () => import("/src/pages/settings/index.vue")
  },
  {
    name: "settings___fr",
    path: "/parametres",
    component: () => import("/src/pages/settings/index.vue")
  },
  {
    name: "settings___es",
    path: "/es/configuracion",
    component: () => import("/src/pages/settings/index.vue")
  },
  {
    name: "settings___ro",
    path: "/ro/setari",
    component: () => import("/src/pages/settings/index.vue")
  },
  {
    name: "notifiche___it",
    path: "/it/notifiche",
    component: () => import("/src/pages/notifiche/index.vue")
  },
  {
    name: "notifiche___en",
    path: "/en/notifications",
    component: () => import("/src/pages/notifiche/index.vue")
  },
  {
    name: "notifiche___fr",
    path: "/notifications",
    component: () => import("/src/pages/notifiche/index.vue")
  },
  {
    name: "notifiche___es",
    path: "/es/notificaciones",
    component: () => import("/src/pages/notifiche/index.vue")
  },
  {
    name: "notifiche___ro",
    path: "/ro/notificari",
    component: () => import("/src/pages/notifiche/index.vue")
  },
  {
    name: "crm-prospect-id___it",
    path: "/it/marketing/prospect/:id()",
    component: () => import("/src/pages/crm/prospect/[id].vue")
  },
  {
    name: "crm-prospect-id___en",
    path: "/en/marketing/prospects/:id()",
    component: () => import("/src/pages/crm/prospect/[id].vue")
  },
  {
    name: "crm-prospect-id___fr",
    path: "/marketing/prospects/:id()",
    component: () => import("/src/pages/crm/prospect/[id].vue")
  },
  {
    name: "crm-prospect-id___es",
    path: "/es/marketing/prospectos/:id()",
    component: () => import("/src/pages/crm/prospect/[id].vue")
  },
  {
    name: "crm-prospect-id___ro",
    path: "/ro/marketing/prospecti/:id()",
    component: () => import("/src/pages/crm/prospect/[id].vue")
  },
  {
    name: "crm-prospect___it",
    path: "/it/marketing/prospect",
    component: () => import("/src/pages/crm/prospect/index.vue")
  },
  {
    name: "crm-prospect___en",
    path: "/en/marketing/prospects",
    component: () => import("/src/pages/crm/prospect/index.vue")
  },
  {
    name: "crm-prospect___fr",
    path: "/marketing/prospects",
    component: () => import("/src/pages/crm/prospect/index.vue")
  },
  {
    name: "crm-prospect___es",
    path: "/es/marketing/prospectos",
    component: () => import("/src/pages/crm/prospect/index.vue")
  },
  {
    name: "crm-prospect___ro",
    path: "/ro/marketing/prospecti",
    component: () => import("/src/pages/crm/prospect/index.vue")
  },
  {
    name: "crm-calendario___it",
    path: "/it/marketing/calendario",
    component: () => import("/src/pages/crm/calendario/index.vue")
  },
  {
    name: "crm-calendario___en",
    path: "/en/marketing/calendar",
    component: () => import("/src/pages/crm/calendario/index.vue")
  },
  {
    name: "crm-calendario___fr",
    path: "/marketing/calendrier",
    component: () => import("/src/pages/crm/calendario/index.vue")
  },
  {
    name: "crm-calendario___es",
    path: "/es/marketing/calendario",
    component: () => import("/src/pages/crm/calendario/index.vue")
  },
  {
    name: "crm-calendario___ro",
    path: "/ro/marketing/calendar",
    component: () => import("/src/pages/crm/calendario/index.vue")
  },
  {
    name: "amministrazione___it",
    path: "/it/amministrazione",
    component: () => import("/src/pages/amministrazione/index.vue")
  },
  {
    name: "amministrazione___en",
    path: "/en/administration",
    component: () => import("/src/pages/amministrazione/index.vue")
  },
  {
    name: "amministrazione___fr",
    path: "/administration",
    component: () => import("/src/pages/amministrazione/index.vue")
  },
  {
    name: "amministrazione___es",
    path: "/es/administracion",
    component: () => import("/src/pages/amministrazione/index.vue")
  },
  {
    name: "amministrazione___ro",
    path: "/ro/administrare",
    component: () => import("/src/pages/amministrazione/index.vue")
  },
  {
    name: "public-password-reset___it",
    path: "/it/public/password-reset",
    meta: password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta || {},
    component: () => import("/src/pages/public/password-reset.vue")
  },
  {
    name: "public-password-reset___en",
    path: "/en/public/password-reset",
    meta: password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta || {},
    component: () => import("/src/pages/public/password-reset.vue")
  },
  {
    name: "public-password-reset___fr",
    path: "/public/password-reset",
    meta: password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta || {},
    component: () => import("/src/pages/public/password-reset.vue")
  },
  {
    name: "public-password-reset___es",
    path: "/es/public/password-reset",
    meta: password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta || {},
    component: () => import("/src/pages/public/password-reset.vue")
  },
  {
    name: "public-password-reset___ro",
    path: "/ro/public/password-reset",
    meta: password_45resetqNels7ZyVlKV1og9bP_Gy247CNZrUyJFarSjGhFOSXUMeta || {},
    component: () => import("/src/pages/public/password-reset.vue")
  },
  {
    name: "pulizia-gestione___it",
    path: "/it/pulizia/gestione",
    component: () => import("/src/pages/pulizia/gestione/index.vue")
  },
  {
    name: "pulizia-gestione___en",
    path: "/en/cleaning/management",
    component: () => import("/src/pages/pulizia/gestione/index.vue")
  },
  {
    name: "pulizia-gestione___fr",
    path: "/nettoyage/gestion",
    component: () => import("/src/pages/pulizia/gestione/index.vue")
  },
  {
    name: "pulizia-gestione___es",
    path: "/es/limpieza/gestion",
    component: () => import("/src/pages/pulizia/gestione/index.vue")
  },
  {
    name: "pulizia-gestione___ro",
    path: "/ro/curatenie/gestionare",
    component: () => import("/src/pages/pulizia/gestione/index.vue")
  },
  {
    name: "anagrafica-clienti-id___it",
    path: "/it/anagrafica/clienti/:id()",
    component: () => import("/src/pages/anagrafica/clienti/[id].vue")
  },
  {
    name: "anagrafica-clienti-id___en",
    path: "/en/registry/clients/:id()",
    component: () => import("/src/pages/anagrafica/clienti/[id].vue")
  },
  {
    name: "anagrafica-clienti-id___fr",
    path: "/registre/clients/:id()",
    component: () => import("/src/pages/anagrafica/clienti/[id].vue")
  },
  {
    name: "anagrafica-clienti-id___es",
    path: "/es/registro/clientes/:id()",
    component: () => import("/src/pages/anagrafica/clienti/[id].vue")
  },
  {
    name: "anagrafica-clienti-id___ro",
    path: "/ro/registru/clienti/:id()",
    component: () => import("/src/pages/anagrafica/clienti/[id].vue")
  },
  {
    name: "magazzino-esolver___it",
    path: "/it/magazzino/esolver",
    component: () => import("/src/pages/magazzino/esolver/index.vue")
  },
  {
    name: "magazzino-esolver___en",
    path: "/en/warehouse/esolver",
    component: () => import("/src/pages/magazzino/esolver/index.vue")
  },
  {
    name: "magazzino-esolver___fr",
    path: "/entrepot/esolver",
    component: () => import("/src/pages/magazzino/esolver/index.vue")
  },
  {
    name: "magazzino-esolver___es",
    path: "/es/almacen/esolver",
    component: () => import("/src/pages/magazzino/esolver/index.vue")
  },
  {
    name: "magazzino-esolver___ro",
    path: "/ro/depozit/esolver",
    component: () => import("/src/pages/magazzino/esolver/index.vue")
  },
  {
    name: "anagrafica-clienti___it",
    path: "/it/anagrafica/clienti",
    component: () => import("/src/pages/anagrafica/clienti/index.vue")
  },
  {
    name: "anagrafica-clienti___en",
    path: "/en/registry/clients",
    component: () => import("/src/pages/anagrafica/clienti/index.vue")
  },
  {
    name: "anagrafica-clienti___fr",
    path: "/registre/clients",
    component: () => import("/src/pages/anagrafica/clienti/index.vue")
  },
  {
    name: "anagrafica-clienti___es",
    path: "/es/registro/clientes",
    component: () => import("/src/pages/anagrafica/clienti/index.vue")
  },
  {
    name: "anagrafica-clienti___ro",
    path: "/ro/registru/clienti",
    component: () => import("/src/pages/anagrafica/clienti/index.vue")
  },
  {
    name: "magazzino-articoli___it",
    path: "/it/magazzino/articoli",
    component: () => import("/src/pages/magazzino/articoli/index.vue")
  },
  {
    name: "magazzino-articoli___en",
    path: "/en/warehouse/items",
    component: () => import("/src/pages/magazzino/articoli/index.vue")
  },
  {
    name: "magazzino-articoli___fr",
    path: "/registre/articles",
    component: () => import("/src/pages/magazzino/articoli/index.vue")
  },
  {
    name: "magazzino-articoli___es",
    path: "/es/almacen/articulos",
    component: () => import("/src/pages/magazzino/articoli/index.vue")
  },
  {
    name: "magazzino-articoli___ro",
    path: "/ro/depozit/articole",
    component: () => import("/src/pages/magazzino/articoli/index.vue")
  },
  {
    name: "magazzino-gestione___it",
    path: "/it/magazzino/gestione",
    component: () => import("/src/pages/magazzino/gestione/index.vue")
  },
  {
    name: "magazzino-gestione___en",
    path: "/en/warehouse/management",
    component: () => import("/src/pages/magazzino/gestione/index.vue")
  },
  {
    name: "magazzino-gestione___fr",
    path: "/entrepot/gestion",
    component: () => import("/src/pages/magazzino/gestione/index.vue")
  },
  {
    name: "magazzino-gestione___es",
    path: "/es/almacen/gestion",
    component: () => import("/src/pages/magazzino/gestione/index.vue")
  },
  {
    name: "magazzino-gestione___ro",
    path: "/ro/depozit/gestionare",
    component: () => import("/src/pages/magazzino/gestione/index.vue")
  },
  {
    name: "prestazioni-offerte-id___it",
    path: "/it/prestazioni/offerte/:id()",
    component: () => import("/src/pages/prestazioni/offerte/[id].vue")
  },
  {
    name: "prestazioni-offerte-id___en",
    path: "/en/services/offers/:id()",
    component: () => import("/src/pages/prestazioni/offerte/[id].vue")
  },
  {
    name: "prestazioni-offerte-id___fr",
    path: "/prestations/offres/:id()",
    component: () => import("/src/pages/prestazioni/offerte/[id].vue")
  },
  {
    name: "prestazioni-offerte-id___es",
    path: "/es/servicios/ofertas/:id()",
    component: () => import("/src/pages/prestazioni/offerte/[id].vue")
  },
  {
    name: "prestazioni-offerte-id___ro",
    path: "/ro/servicii/oferte/:id()",
    component: () => import("/src/pages/prestazioni/offerte/[id].vue")
  },
  {
    name: "prestazioni-ordini___it",
    path: "/it/prestazioni/ordini",
    component: () => import("/src/pages/prestazioni/ordini/index.vue")
  },
  {
    name: "prestazioni-ordini___en",
    path: "/en/services/orders",
    component: () => import("/src/pages/prestazioni/ordini/index.vue")
  },
  {
    name: "prestazioni-ordini___fr",
    path: "/prestations/commandes",
    component: () => import("/src/pages/prestazioni/ordini/index.vue")
  },
  {
    name: "prestazioni-ordini___es",
    path: "/es/servicios/pedidos",
    component: () => import("/src/pages/prestazioni/ordini/index.vue")
  },
  {
    name: "prestazioni-ordini___ro",
    path: "/ro/servicii/comenzi",
    component: () => import("/src/pages/prestazioni/ordini/index.vue")
  },
  {
    name: "pulizia-calendario___it",
    path: "/it/pulizia/calendario",
    component: () => import("/src/pages/pulizia/calendario/index.vue")
  },
  {
    name: "pulizia-calendario___en",
    path: "/en/cleaning/calendar",
    component: () => import("/src/pages/pulizia/calendario/index.vue")
  },
  {
    name: "pulizia-calendario___fr",
    path: "/nettoyage/calendrier",
    component: () => import("/src/pages/pulizia/calendario/index.vue")
  },
  {
    name: "pulizia-calendario___es",
    path: "/es/limpieza/calendario",
    component: () => import("/src/pages/pulizia/calendario/index.vue")
  },
  {
    name: "pulizia-calendario___ro",
    path: "/ro/curatenie/calendar",
    component: () => import("/src/pages/pulizia/calendario/index.vue")
  },
  {
    name: "commerciale-listini___it",
    path: "/it/commerciale/listini",
    component: () => import("/src/pages/commerciale/listini/index.vue")
  },
  {
    name: "commerciale-listini___en",
    path: "/en/registry/pricelists",
    component: () => import("/src/pages/commerciale/listini/index.vue")
  },
  {
    name: "commerciale-listini___fr",
    path: "/registre/tarifs",
    component: () => import("/src/pages/commerciale/listini/index.vue")
  },
  {
    name: "commerciale-listini___es",
    path: "/es/registro/listas-de-precios",
    component: () => import("/src/pages/commerciale/listini/index.vue")
  },
  {
    name: "commerciale-listini___ro",
    path: "/ro/registru/liste-preturi",
    component: () => import("/src/pages/commerciale/listini/index.vue")
  },
  {
    name: "magazzino-automezzi___it",
    path: "/it/magazzino/automezzi",
    component: () => import("/src/pages/magazzino/automezzi/index.vue")
  },
  {
    name: "magazzino-automezzi___en",
    path: "/en/warehouse/vehicles",
    component: () => import("/src/pages/magazzino/automezzi/index.vue")
  },
  {
    name: "magazzino-automezzi___fr",
    path: "/entrepot/vehicules",
    component: () => import("/src/pages/magazzino/automezzi/index.vue")
  },
  {
    name: "magazzino-automezzi___es",
    path: "/es/almacen/vehiculos",
    component: () => import("/src/pages/magazzino/automezzi/index.vue")
  },
  {
    name: "magazzino-automezzi___ro",
    path: "/ro/depozit/autovehicule",
    component: () => import("/src/pages/magazzino/automezzi/index.vue")
  },
  {
    name: "prestazioni-offerte___it",
    path: "/it/prestazioni/offerte",
    component: () => import("/src/pages/prestazioni/offerte/index.vue")
  },
  {
    name: "prestazioni-offerte___en",
    path: "/en/services/offers",
    component: () => import("/src/pages/prestazioni/offerte/index.vue")
  },
  {
    name: "prestazioni-offerte___fr",
    path: "/prestations/offres",
    component: () => import("/src/pages/prestazioni/offerte/index.vue")
  },
  {
    name: "prestazioni-offerte___es",
    path: "/es/servicios/ofertas",
    component: () => import("/src/pages/prestazioni/offerte/index.vue")
  },
  {
    name: "prestazioni-offerte___ro",
    path: "/ro/servicii/oferte",
    component: () => import("/src/pages/prestazioni/offerte/index.vue")
  },
  {
    name: "anagrafica-capi_area___it",
    path: "/it/anagrafica/capi_area",
    component: () => import("/src/pages/anagrafica/capi_area/index.vue")
  },
  {
    name: "anagrafica-capi_area___en",
    path: "/en/registry/area-managers",
    component: () => import("/src/pages/anagrafica/capi_area/index.vue")
  },
  {
    name: "anagrafica-capi_area___fr",
    path: "/registre/chefs-de-zone",
    component: () => import("/src/pages/anagrafica/capi_area/index.vue")
  },
  {
    name: "anagrafica-capi_area___es",
    path: "/es/registro/jefes-de-zona",
    component: () => import("/src/pages/anagrafica/capi_area/index.vue")
  },
  {
    name: "anagrafica-capi_area___ro",
    path: "/ro/registru/sefi-zona",
    component: () => import("/src/pages/anagrafica/capi_area/index.vue")
  },
  {
    name: "amministrazione-fatture___it",
    path: "/it/amministrazione/fatture",
    component: () => import("/src/pages/amministrazione/fatture/index.vue")
  },
  {
    name: "amministrazione-fatture___en",
    path: "/en/administration/invoices",
    component: () => import("/src/pages/amministrazione/fatture/index.vue")
  },
  {
    name: "amministrazione-fatture___fr",
    path: "/administration/factures",
    component: () => import("/src/pages/amministrazione/fatture/index.vue")
  },
  {
    name: "amministrazione-fatture___es",
    path: "/es/administracion/facturas",
    component: () => import("/src/pages/amministrazione/fatture/index.vue")
  },
  {
    name: "amministrazione-fatture___ro",
    path: "/ro/administrare/facturi",
    component: () => import("/src/pages/amministrazione/fatture/index.vue")
  },
  {
    name: "anagrafica-concessionari-id___it",
    path: "/it/anagrafica/concessionari/:id()",
    component: () => import("/src/pages/anagrafica/concessionari/[id].vue")
  },
  {
    name: "anagrafica-concessionari-id___en",
    path: "/en/registry/dealers/:id()",
    component: () => import("/src/pages/anagrafica/concessionari/[id].vue")
  },
  {
    name: "anagrafica-concessionari-id___fr",
    path: "/registre/concessionnaires/:id()",
    component: () => import("/src/pages/anagrafica/concessionari/[id].vue")
  },
  {
    name: "anagrafica-concessionari-id___es",
    path: "/es/registro/concesionarios/:id()",
    component: () => import("/src/pages/anagrafica/concessionari/[id].vue")
  },
  {
    name: "anagrafica-concessionari-id___ro",
    path: "/ro/registru/dealeri/:id()",
    component: () => import("/src/pages/anagrafica/concessionari/[id].vue")
  },
  {
    name: "prestazioni-ordini-id___it",
    path: "/it/prestazioni/ordini/:id()",
    component: () => import("/src/pages/prestazioni/ordini/[id]/index.vue")
  },
  {
    name: "prestazioni-ordini-id___en",
    path: "/en/services/orders/:id()",
    component: () => import("/src/pages/prestazioni/ordini/[id]/index.vue")
  },
  {
    name: "prestazioni-ordini-id___fr",
    path: "/prestations/commandes/:id()",
    component: () => import("/src/pages/prestazioni/ordini/[id]/index.vue")
  },
  {
    name: "prestazioni-ordini-id___es",
    path: "/es/servicios/pedidos/:id()",
    component: () => import("/src/pages/prestazioni/ordini/[id]/index.vue")
  },
  {
    name: "prestazioni-ordini-id___ro",
    path: "/ro/servicii/comenzi/:id()",
    component: () => import("/src/pages/prestazioni/ordini/[id]/index.vue")
  },
  {
    name: "prestazioni-ordini-crea___it",
    path: "/it/prestazioni/ordini/crea",
    component: () => import("/src/pages/prestazioni/ordini/crea/index.vue")
  },
  {
    name: "prestazioni-ordini-crea___en",
    path: "/en/services/orders/create",
    component: () => import("/src/pages/prestazioni/ordini/crea/index.vue")
  },
  {
    name: "prestazioni-ordini-crea___fr",
    path: "/prestations/commandes/creer",
    component: () => import("/src/pages/prestazioni/ordini/crea/index.vue")
  },
  {
    name: "prestazioni-ordini-crea___es",
    path: "/es/servicios/pedidos/crear",
    component: () => import("/src/pages/prestazioni/ordini/crea/index.vue")
  },
  {
    name: "prestazioni-ordini-crea___ro",
    path: "/ro/servicii/comenzi/creare",
    component: () => import("/src/pages/prestazioni/ordini/crea/index.vue")
  },
  {
    name: "anagrafica-concessionari___it",
    path: "/it/anagrafica/concessionari",
    component: () => import("/src/pages/anagrafica/concessionari/index.vue")
  },
  {
    name: "anagrafica-concessionari___en",
    path: "/en/registry/dealers",
    component: () => import("/src/pages/anagrafica/concessionari/index.vue")
  },
  {
    name: "anagrafica-concessionari___fr",
    path: "/registre/concessionnaires",
    component: () => import("/src/pages/anagrafica/concessionari/index.vue")
  },
  {
    name: "anagrafica-concessionari___es",
    path: "/es/registro/concesionarios",
    component: () => import("/src/pages/anagrafica/concessionari/index.vue")
  },
  {
    name: "anagrafica-concessionari___ro",
    path: "/ro/registru/dealeri",
    component: () => import("/src/pages/anagrafica/concessionari/index.vue")
  },
  {
    name: "anagrafica-gestione_file___it",
    path: "/it/anagrafica/gestione_file",
    component: () => import("/src/pages/anagrafica/gestione_file/index.vue")
  },
  {
    name: "anagrafica-gestione_file___en",
    path: "/en/registry/file-management",
    component: () => import("/src/pages/anagrafica/gestione_file/index.vue")
  },
  {
    name: "anagrafica-gestione_file___fr",
    path: "/registre/gestion-fichiers",
    component: () => import("/src/pages/anagrafica/gestione_file/index.vue")
  },
  {
    name: "anagrafica-gestione_file___es",
    path: "/es/registro/gestion-archivos",
    component: () => import("/src/pages/anagrafica/gestione_file/index.vue")
  },
  {
    name: "anagrafica-gestione_file___ro",
    path: "/ro/registru/gestionare-fisiere",
    component: () => import("/src/pages/anagrafica/gestione_file/index.vue")
  },
  {
    name: "prestazioni-offerte-crea___it",
    path: "/it/prestazioni/offerte/crea",
    component: () => import("/src/pages/prestazioni/offerte/crea/index.vue")
  },
  {
    name: "prestazioni-offerte-crea___en",
    path: "/en/services/offers/create",
    component: () => import("/src/pages/prestazioni/offerte/crea/index.vue")
  },
  {
    name: "prestazioni-offerte-crea___fr",
    path: "/prestations/offres/creer",
    component: () => import("/src/pages/prestazioni/offerte/crea/index.vue")
  },
  {
    name: "prestazioni-offerte-crea___es",
    path: "/es/servicios/ofertas/crear",
    component: () => import("/src/pages/prestazioni/offerte/crea/index.vue")
  },
  {
    name: "prestazioni-offerte-crea___ro",
    path: "/ro/servicii/oferte/creare",
    component: () => import("/src/pages/prestazioni/offerte/crea/index.vue")
  },
  {
    name: "prestazioni-offerte-recap-id___it",
    path: "/it/prestazioni/offerte/recap/:id()",
    component: () => import("/src/pages/prestazioni/offerte/recap/[id].vue")
  },
  {
    name: "prestazioni-offerte-recap-id___en",
    path: "/en/services/offers/recap/:id()",
    component: () => import("/src/pages/prestazioni/offerte/recap/[id].vue")
  },
  {
    name: "prestazioni-offerte-recap-id___fr",
    path: "/prestations/offres/recap/:id()",
    component: () => import("/src/pages/prestazioni/offerte/recap/[id].vue")
  },
  {
    name: "prestazioni-offerte-recap-id___es",
    path: "/es/servicios/ofertas/recap/:id()",
    component: () => import("/src/pages/prestazioni/offerte/recap/[id].vue")
  },
  {
    name: "prestazioni-offerte-recap-id___ro",
    path: "/ro/servicii/oferte/recap/:id()",
    component: () => import("/src/pages/prestazioni/offerte/recap/[id].vue")
  },
  {
    name: "amministrazione-insurance___it",
    path: "/it/amministrazione/insurance",
    component: () => import("/src/pages/amministrazione/insurance/index.vue")
  },
  {
    name: "amministrazione-insurance___en",
    path: "/en/administration/insurance",
    component: () => import("/src/pages/amministrazione/insurance/index.vue")
  },
  {
    name: "amministrazione-insurance___fr",
    path: "/administration/assurance",
    component: () => import("/src/pages/amministrazione/insurance/index.vue")
  },
  {
    name: "amministrazione-insurance___es",
    path: "/es/administracion/seguros",
    component: () => import("/src/pages/amministrazione/insurance/index.vue")
  },
  {
    name: "amministrazione-insurance___ro",
    path: "/ro/administrare/asigurari",
    component: () => import("/src/pages/amministrazione/insurance/index.vue")
  },
  {
    name: "amministrazione-pro-forma___it",
    path: "/it/amministrazione/pro-forma",
    component: () => import("/src/pages/amministrazione/pro-forma/index.vue")
  },
  {
    name: "amministrazione-pro-forma___en",
    path: "/en/administration/pro-forma",
    component: () => import("/src/pages/amministrazione/pro-forma/index.vue")
  },
  {
    name: "amministrazione-pro-forma___fr",
    path: "/administration/pro-forma",
    component: () => import("/src/pages/amministrazione/pro-forma/index.vue")
  },
  {
    name: "amministrazione-pro-forma___es",
    path: "/es/administracion/pro-forma",
    component: () => import("/src/pages/amministrazione/pro-forma/index.vue")
  },
  {
    name: "amministrazione-pro-forma___ro",
    path: "/ro/administrare/pro-forma",
    component: () => import("/src/pages/amministrazione/pro-forma/index.vue")
  },
  {
    name: "commerciale-tipi_locazione___it",
    path: "/it/commerciale/tipi_locazione",
    component: () => import("/src/pages/commerciale/tipi_locazione/index.vue")
  },
  {
    name: "commerciale-tipi_locazione___en",
    path: "/en/registry/rental-types",
    component: () => import("/src/pages/commerciale/tipi_locazione/index.vue")
  },
  {
    name: "commerciale-tipi_locazione___fr",
    path: "/registre/types-location",
    component: () => import("/src/pages/commerciale/tipi_locazione/index.vue")
  },
  {
    name: "commerciale-tipi_locazione___es",
    path: "/es/registro/tipos-de-alquiler",
    component: () => import("/src/pages/commerciale/tipi_locazione/index.vue")
  },
  {
    name: "commerciale-tipi_locazione___ro",
    path: "/ro/registru/tipuri-inchiriere",
    component: () => import("/src/pages/commerciale/tipi_locazione/index.vue")
  },
  {
    name: "prestazioni-offerte-importa___it",
    path: "/it/prestazioni/offerte/importa",
    component: () => import("/src/pages/prestazioni/offerte/importa/index.vue")
  },
  {
    name: "prestazioni-offerte-importa___en",
    path: "/en/services/offers/import",
    component: () => import("/src/pages/prestazioni/offerte/importa/index.vue")
  },
  {
    name: "prestazioni-offerte-importa___fr",
    path: "/prestations/offres/importer",
    component: () => import("/src/pages/prestazioni/offerte/importa/index.vue")
  },
  {
    name: "prestazioni-offerte-importa___es",
    path: "/es/servicios/ofertas/importar",
    component: () => import("/src/pages/prestazioni/offerte/importa/index.vue")
  },
  {
    name: "prestazioni-offerte-importa___ro",
    path: "/ro/servicii/oferte/import",
    component: () => import("/src/pages/prestazioni/offerte/importa/index.vue")
  },
  {
    name: "pulizia-anagrafica-pulitori___it",
    path: "/it/pulizia/anagrafica-operatori",
    component: () => import("/src/pages/pulizia/anagrafica-pulitori/index.vue")
  },
  {
    name: "pulizia-anagrafica-pulitori___en",
    path: "/en/cleaning/route-operators-registry",
    component: () => import("/src/pages/pulizia/anagrafica-pulitori/index.vue")
  },
  {
    name: "pulizia-anagrafica-pulitori___fr",
    path: "/nettoyage/registre-operateurs",
    component: () => import("/src/pages/pulizia/anagrafica-pulitori/index.vue")
  },
  {
    name: "pulizia-anagrafica-pulitori___es",
    path: "/es/limpieza/registro-operadores",
    component: () => import("/src/pages/pulizia/anagrafica-pulitori/index.vue")
  },
  {
    name: "pulizia-anagrafica-pulitori___ro",
    path: "/ro/curatenie/registru-operatori",
    component: () => import("/src/pages/pulizia/anagrafica-pulitori/index.vue")
  },
  {
    name: "password-reset-confirm-uid-token___it",
    path: "/it/password-reset/confirm/:uid()/:token()",
    meta: _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta || {},
    component: () => import("/src/pages/password-reset/confirm/[uid]/[token].vue")
  },
  {
    name: "password-reset-confirm-uid-token___en",
    path: "/en/password-reset/confirm/:uid()/:token()",
    meta: _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta || {},
    component: () => import("/src/pages/password-reset/confirm/[uid]/[token].vue")
  },
  {
    name: "password-reset-confirm-uid-token___fr",
    path: "/password-reset/confirm/:uid()/:token()",
    meta: _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta || {},
    component: () => import("/src/pages/password-reset/confirm/[uid]/[token].vue")
  },
  {
    name: "password-reset-confirm-uid-token___es",
    path: "/es/password-reset/confirm/:uid()/:token()",
    meta: _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta || {},
    component: () => import("/src/pages/password-reset/confirm/[uid]/[token].vue")
  },
  {
    name: "password-reset-confirm-uid-token___ro",
    path: "/ro/password-reset/confirm/:uid()/:token()",
    meta: _91token_93b3LDQHrlSY40Ra6z_458mIKymCxt7IUbhf9CcNNPStPDkMeta || {},
    component: () => import("/src/pages/password-reset/confirm/[uid]/[token].vue")
  },
  {
    name: "amministrazione-fatture-veicoli___it",
    path: "/it/amministrazione/fatture-veicoli",
    component: () => import("/src/pages/amministrazione/fatture-veicoli/index.vue")
  },
  {
    name: "amministrazione-fatture-veicoli___en",
    path: "/en/administration/vehicle-invoices",
    component: () => import("/src/pages/amministrazione/fatture-veicoli/index.vue")
  },
  {
    name: "amministrazione-fatture-veicoli___fr",
    path: "/administration/factures-vehicules",
    component: () => import("/src/pages/amministrazione/fatture-veicoli/index.vue")
  },
  {
    name: "amministrazione-fatture-veicoli___es",
    path: "/es/administracion/facturas-vehiculos",
    component: () => import("/src/pages/amministrazione/fatture-veicoli/index.vue")
  },
  {
    name: "amministrazione-fatture-veicoli___ro",
    path: "/ro/administrare/facturi-vehicule",
    component: () => import("/src/pages/amministrazione/fatture-veicoli/index.vue")
  },
  {
    name: "amministrazione-riepilogo-fatture___it",
    path: "/it/amministrazione/riepilogo-fatture",
    component: () => import("/src/pages/amministrazione/riepilogo-fatture/index.vue")
  },
  {
    name: "amministrazione-riepilogo-fatture___en",
    path: "/en/amministrazione/riepilogo-fatture",
    component: () => import("/src/pages/amministrazione/riepilogo-fatture/index.vue")
  },
  {
    name: "amministrazione-riepilogo-fatture___fr",
    path: "/amministrazione/riepilogo-fatture",
    component: () => import("/src/pages/amministrazione/riepilogo-fatture/index.vue")
  },
  {
    name: "amministrazione-riepilogo-fatture___es",
    path: "/es/amministrazione/riepilogo-fatture",
    component: () => import("/src/pages/amministrazione/riepilogo-fatture/index.vue")
  },
  {
    name: "amministrazione-riepilogo-fatture___ro",
    path: "/ro/amministrazione/riepilogo-fatture",
    component: () => import("/src/pages/amministrazione/riepilogo-fatture/index.vue")
  }
]